import type { IconData } from '@stacksjs/iconify-core'

export const chevronDoubleLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M276.055 143.463L196.592 64L87.571 173.021l-.041-.041l-68.149 68.148l-4.3 4.328l-7.085 7l68.217 68.216l11.342 11.26l109.037 109.035l79.463-79.467l-109.021-109.016Zm-79.463 252.249l-97.707-97.707l-11.355-11.273l-34.182-34.181l.041-.041l-.067-.068l34.208-34.207l.041.041l109.021-109.021l34.208 34.208l-109.021 109.021L230.8 361.5Z\"/><path fill=\"currentColor\" d=\"M497.263 143.463L417.8 64L308.713 173.088l-.042-.041l-68.081 68.081l-11.19 11.278l-.119.119l68.148 68.148l11.288 11.2L417.8 440.967l79.463-79.467l-109.021-109.016ZM452.008 361.5L417.8 395.712l-97.707-97.707l-11.28-11.2l-34.325-34.324l34.316-34.316l.042.041L417.8 109.255l34.207 34.208l-109.02 109.021Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default chevronDoubleLeft
